module.exports = __webpack_public_path__ + "img/lg_ring_y_c_null_null@3x.db04e135.png";